<page-heading
  [title]="'report.tracking.title' | translate"
  [description]="'report.tracking.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <ul class="nav nav-tabs nav-bordered" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link active"
          id="dash-tab"
          data-bs-toggle="tab"
          data-bs-target="#dash"
          type="button"
          role="tab"
          aria-controls="dash"
          aria-selected="true"
        >
          <i
            class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
          ></i>
          <span class="d-none d-md-inline">{{ 'report.tracking.tabDashboard' | translate }}</span>
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          id="tracker-list-tab"
          data-bs-toggle="tab"
          data-bs-target="#tracker-list"
          type="button"
          role="tab"
          aria-controls="tracker-list"
          aria-selected="false"
        >
          <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
          <span class="d-none d-md-inline">{{ 'report.tracking.tabTrackerList' | translate }}</span>
        </a>
      </li>
    </ul>

    <div class="mt-3">
      <div class="tab-content" id="tabReportTrackerContent">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <form [formGroup]="formGroup">
                  <div class="row">
                    <div class="col-xs-12 col-lg-4 mt-2 input-trend-search">
                      <input
                        type="search"
                        #searchBox
                        class="form-control"
                        [placeholder]="'report.tracking.searchPlaceholder' | translate"
                        (keyup)="search(searchBox.value)"
                      />
                      <span class="mdi mdi-magnify search-icon ml-2"></span>
                    </div>

                    <div class="col-xs-12 col-lg-3 mt-2 trend-datepicker">
                      <mat-date-range-input
                        [rangePicker]="picker"
                        formGroupName="dateRange"
                      >
                        <input
                          matStartDate
                          [placeholder]="'report.tracking.startDate' | translate"
                          formControlName="dateStart"
                        />
                        <input
                          matEndDate
                          [placeholder]="'report.tracking.endDate' | translate"
                          formControlName="dateEnd"
                        />
                      </mat-date-range-input>
                      <mat-datepicker-toggle matIconSuffix [for]="picker" />
                      <mat-date-range-picker #picker>
                        <mat-datepicker-actions>
                          <mat-select
                            class="input-field rounded-lg"
                            (selectionChange)="onPeriodChange($event)"
                            [placeholder]="'report.tracking.selectPlaceholder' | translate"
                          >
                            <mat-option value="1">{{ 'report.tracking.periodToday' | translate }}</mat-option>
                            <mat-option value="7">{{ 'report.tracking.periodLast7Days' | translate }}</mat-option>
                            <mat-option value="15">{{ 'report.tracking.periodLast15Days' | translate }}</mat-option>
                            <mat-option value="30">{{ 'report.tracking.periodLast30Days' | translate }}</mat-option>
                            <mat-option value="60">{{ 'report.tracking.periodLast60Days' | translate }}</mat-option>
                          </mat-select>
                          <button
                            mat-raised-button
                            matDatepickerApply
                            class="btnOk"
                          >
                            {{ 'report.tracking.ok' | translate }}
                          </button>
                        </mat-datepicker-actions>
                      </mat-date-range-picker>
                    </div>

                    <div
                      class="col-xs-6 col-md-6 col-lg-3 mt-2 btn-group trend-button"
                    >
                      <button
                        type="submit"
                        [matMenuTriggerFor]="filterOrigin"
                        class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle text-truncate mw-100"
                      >
                        <span>
                          {{ originLabel | translate }}
                        </span>
                      </button>
                      <mat-menu #filterOrigin class="custom-menu-panel">
                        <button mat-menu-item (click)="searchByOrigin(null)">
                          {{ 'report.tracking.all' | translate }}
                        </button>
                        @for (origin of listOrigin; track $index) {
                          <button
                            mat-menu-item
                            (click)="searchByOrigin(origin)"
                          >
                            {{ getTranslatedTracker(origin) }}
                          </button>
                        }
                      </mat-menu>
                    </div>

                    <div
                      class="col-xs-6 col-md-6 col-lg-1 mt-2 btn-group trend-button"
                      (click)="exportTrackerReportToExcel()"
                    >
                      <button
                        class="btn btn-primary fw-bold"
                        [disabled]="isLoading"
                        [ngClass]="{
                          'cursor-not-allowed opacity-50': isLoading,
                          'cursor-pointer': !isLoading,
                        }"
                        [matTooltip]="'report.tracking.exportExcel' | translate"
                      >
                        @if (isLoading) {
                          <mat-spinner
                            [diameter]="25"
                            mode="indeterminate"
                          ></mat-spinner>
                        } @else {
                          <i class="ri-file-text-line"></i>
                        }
                      </button>
                    </div>

                    <div
                      class="col-xs-6 col-md-6 col-lg-1 mt-2 btn-group trend-button"
                      (click)="exportTrackerReportToPDF()"
                    >
                      <button
                        class="btn btn-primary fw-bold"
                        [disabled]="isLoading"
                        [ngClass]="{
                          'cursor-not-allowed opacity-50': isLoading,
                          'cursor-pointer': !isLoading,
                        }"
                        [matTooltip]="'report.tracking.exportPdf' | translate"
                      >
                        @if (isLoading) {
                          <mat-spinner
                            [diameter]="25"
                            mode="indeterminate"
                          ></mat-spinner>
                        } @else {
                          <i class="ri-share-box-fill"></i>
                        }
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- DASHBOARD  -->
        <div
          class="tab-pane fade show active custom-scroll-bar card-upload-csv overflow-x-hidden"
          id="dash"
          role="tabpanel"
          aria-labelledby="dash-tab"
        >
          <div class="row g-2 mb-3">
            @for (kpi of kpis; track kpi.label) {
              <div class="col-6 col-md-3">
                <div class="card mb-0 p-2">
                  <div class="card-body py-3">
                    <div class="d-flex flex-column">
                      <h3 class="mt-0">{{ kpi.value }}</h3>
                      <h5 class="text-muted fw-normal mb-0">{{ kpi.label | translate }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="row g-2 mb-2">
            <div class="col-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title fw-bold mb-3">{{ 'report.tracking.leadsPerDay' | translate }}</h4>
                  @if (chartPerDayData && chartPerDayData.length > 0) {
                    <div style="position: relative; height: 260px">
                      <canvas #chartPerDay></canvas>
                    </div>
                  } @else {
                    <empty-records-component
                      [message]="'report.tracking.noDataFound' | translate"
                      [subMessage]="'report.tracking.noDataFoundSub' | translate"
                      [icon]="'mdi  mdi-alert-circle-outline'"
                    />
                  }
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title fw-bold mb-3">{{ 'report.tracking.peakHour' | translate }}</h4>
                  @if (chartPeakHourData && chartPeakHourData.length > 0) {
                    <div style="position: relative; height: 260px">
                      <canvas #chartPeakHour></canvas>
                    </div>
                  } @else {
                    <empty-records-component
                      [message]="'report.tracking.noDataFound' | translate"
                      [subMessage]="'report.tracking.noDataFoundSub' | translate"
                      [icon]="'mdi  mdi-alert-circle-outline'"
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row g-2">
            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title fw-bold mb-3">{{ 'report.tracking.byOrigin' | translate }}</h4>
                  @if (pieChartByOrigin && pieChartByOrigin.length > 0) {
                    <div style="position: relative; height: 260px">
                      <canvas #chartOrigin></canvas>
                    </div>
                  } @else {
                    <empty-records-component
                      [message]="'report.tracking.noDataFound' | translate"
                      [subMessage]="'report.tracking.noDataFoundSub' | translate"
                      [icon]="'mdi mdi-alert-circle-outline'"
                    />
                  }
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title fw-bold mb-3">{{ 'report.tracking.byMediaType' | translate }}</h4>
                  @if (pieChartByMediaType && pieChartByMediaType.length > 0) {
                    <div style="position: relative; height: 260px">
                      <canvas #chartMediaType></canvas>
                    </div>
                  } @else {
                    <empty-records-component
                      [message]="'report.tracking.noDataFound' | translate"
                      [subMessage]="'report.tracking.noDataFoundSub' | translate"
                      [icon]="'mdi mdi-alert-circle-outline'"
                    />
                  }
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title fw-bold mb-3">{{ 'report.tracking.byCampaign' | translate }}</h4>
                  @if (pieChartByCampaign && pieChartByCampaign.length > 0) {
                    <div style="position: relative; height: 260px">
                      <canvas #chartCampaign></canvas>
                    </div>
                  } @else {
                    <empty-records-component
                      [message]="'report.tracking.noDataFound' | translate"
                      [subMessage]="'report.tracking.noDataFoundSub' | translate"
                      [icon]="'mdi mdi-alert-circle-outline'"
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- LISTA DE TRACKEAMENTOS  -->
        <div
          class="tab-pane fade custom-scroll-bar card-upload-csv overflow-x-hidden"
          id="tracker-list"
          role="tabpanel"
          aria-labelledby="tracker-list-tab"
        >
          <div class="card">
            @if (loadingContent) {
              <content-loading-list />
            }

            @if (pager.total == 0) {
              <empty-records-component
                [message]="'report.tracking.noTrackingFound' | translate"
                [subMessage]="'report.tracking.noTrackingFoundSub' | translate"
                [icon]="'mdi mdi-alert-circle-outline'"
              />
            }

            @if (!loadingContent && pager.total > 0) {
              <div class="card-body table-responsive">
                <table class="table table-hover table-centered mb-0">
                  <thead>
                    <tr>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colCreatedAt' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colClient' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colPhone' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colOrigin' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colTitle' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colMainText' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colMediaType' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colAdLink' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'report.tracking.colCreativeId' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (tracker of pager.list; track $index) {
                      <tr
                        class="cursor-pointer"
                        (click)="notify(tracker); $event.stopPropagation()"
                      >
                        <td>
                          <span>{{
                            tracker.createdAt
                              | timezoneDate
                                : "DD/MM/YYYY"
                                : getTimezoneCompanyCurrentUser()
                          }}</span
                          ><br />
                          <span>{{
                            tracker.createdAt
                              | timezoneDate
                                : "HH:mm"
                                : getTimezoneCompanyCurrentUser()
                          }}</span>
                        </td>
                        <td>
                          @if (tracker?.contact?.name?.length > 15) {
                            <span matTooltip="{{ tracker?.contact?.name }}">
                              {{ $safeNavigationMigration(tracker?.contact?.name) | truncate: 15 }}
                            </span>
                          } @else {
                            <span>
                              {{ tracker?.contact?.name }}
                            </span>
                          }
                        </td>
                        <td>
                          @if (tracker?.contact?.phone?.length > 15) {
                            <span matTooltip="{{ tracker?.contact?.phone }}">
                              {{ $safeNavigationMigration(tracker?.contact?.phone) | truncate: 15 }}
                            </span>
                          } @else {
                            <span>
                              {{ tracker?.contact?.phone }}
                            </span>
                          }
                        </td>
                        <td>
                          <span>
                            {{ getTranslatedTracker(tracker.origin) }}
                          </span>
                        </td>
                        <td>
                          <span matTooltip="{{ tracker.referral?.headline }}">
                            {{
                              tracker.referral?.headline ||
                                tracker.referral?.title | truncate: 15
                            }}
                          </span>
                        </td>
                        <td>
                          <span matTooltip="{{ tracker.referral?.body }}">
                            {{
                              tracker.referral?.body
                                ? ($safeNavigationMigration(tracker.referral?.body) | truncate: 15)
                                : "-"
                            }}
                          </span>
                        </td>
                        <td>
                          <span>
                            {{ normalizeMediaTypeLabel(tracker.mediaType) }}
                          </span>
                        </td>
                        <td>
                          <span
                            [matTooltip]="'report.tracking.clickToOpenAd' | translate"
                            (click)="$event.stopPropagation()"
                          >
                            <a
                              [href]="
                                tracker.referral?.source_url ||
                                tracker.referral?.sourceUrl
                              "
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {{
                                tracker.referral?.source_url ||
                                  tracker.referral?.sourceUrl | truncate: 15
                              }}
                            </a>
                          </span>
                        </td>
                        <td>
                          <span
                            matTooltip="{{
                              tracker.referral?.source_id ||
                                tracker.referral?.sourceId
                            }}"
                            (click)="$event.stopPropagation()"
                          >
                            {{
                              tracker.referral?.source_id ||
                                tracker.referral?.sourceId
                            }}
                          </span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>

                @if (pager.total > pager.perPage) {
                  <paginator [pager]="pager" (onPager)="loadPage($event)" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
